import { makeAutoObservable } from "mobx"

export default class AuthenticationHistory {

  constructor(authenticationHistory={}) {
    this.id = authenticationHistory.id
    this.authentication_id = authenticationHistory.authentication_id
    this.follower_count = authenticationHistory.follower_count || 0
    this.following_count = authenticationHistory.following_count || 0
    this.media_count = authenticationHistory.media_count || 0
    this.history_changed_at = authenticationHistory.history_changed_at || ''
    this.average_likes = authenticationHistory.average_likes || 0
    this.average_comments = authenticationHistory.average_comments || 0
      this.avg_reels_plays = authenticationHistory.avg_reels_plays || 0
    this.avg_posts_4_weeks = authenticationHistory.avg_posts_4_weeks || 0

    makeAutoObservable(this)
  }
}
